import React, { useMemo } from "react";
import {
  type MRT_ColumnDef,
} from "material-react-table";
import { Box, useTheme } from "@mui/material";
import { AddNewUserModal } from "./AddNewUserModal";
import { AdminGlobalTable } from "../../../tables/AdminGlobalTable";
import { AdminTableTopToolbar } from "../../common/AdminTableTopToolbar";
import { ActionCell } from "./ActionCell";
type orgColumn = {
  name: string;
  username: string;
  email: string;
};

const SAUserTable = ({ data }) => {
  const theme = useTheme()
  const columns = useMemo<MRT_ColumnDef<orgColumn>[]>(
    () => [
      { header: "NAME", accessorKey: "name" },
      { header: "USERNAME", accessorKey: "username" },
      { header: "EMAIL", accessorKey: "email" },
      {
        header: "ACTION",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        Cell: ActionCell
      },
    ],
    []
  );
  return (
    <>
      <Box>
        <AddNewUserModal />
      </Box>
      <AdminGlobalTable
        columns={columns}
        data={data}
        config={{
          enableSelectAll: true,
          // enableRowSelection: true,
          // muiSelectCheckboxProps: { 
          //   color: "secondary",
          //   sx:{ 
          //     '& input[type="checkbox"]': {
          //     height: '44px !important',
          //   }}
          // },
          muiTableContainerProps: {
            sx: {
              maxHeight: "calc(100vh - 360px)",
              minHeight: "calc(100vh - 360px)",
            },
          },
          muiTableBodyRowProps: () => ({
            hover: false,
            sx: {
              backgroundColor: "transparent",
              ":hover": { backgroundColor: theme.custom.hoverOptionColor },
            },
          }),
          renderTopToolbarCustomActions: ({ table }) => (
            <AdminTableTopToolbar
              title="All User List"
              table={table}
              data={data}
            />
          ),
        }}
      />
    </>
  );
};

export default SAUserTable;
